import React from 'react';
import './App.css';
import PlantCalcDashboard from "./PlantCalc/PlantCalcDashboard";
import {createMuiTheme, ThemeProvider} from '@material-ui/core/styles';
import blueGrey from "@material-ui/core/colors/blueGrey";


const darkTheme = createMuiTheme({
    palette: {
        type: 'dark',
        primary: blueGrey
    },
});

const lightTheme = createMuiTheme({
    palette: {
        type: 'light',
        primary: blueGrey
    },
});


export default function App() {

    const [beagleTheme, setBeagleTheme] = React.useState('dark');

    function toggleBeagleTheme() {
        if (beagleTheme === 'light') {
            setBeagleTheme('dark');
        } else {
            setBeagleTheme('light');
        }
    }


    return (
        <div className="App">
            <ThemeProvider theme={beagleTheme === 'dark' ? darkTheme : lightTheme}>
                <PlantCalcDashboard
                    beagleTheme={beagleTheme}
                    toggleBeagleTheme={toggleBeagleTheme}
                />
            </ThemeProvider>
        </div>
    );

}
